import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import GroupQuestionsEditForm from "./GroupQuestionsEditForm";
import { useGetAvailableLanguages } from "../../hooks/global/Languages";
import { useDrag, useDrop } from 'react-dnd';

function GroupQuestionsListItem({ id, index, type, text, moduleId,  onMove, onDrop, open = false, isSortable=true, onAddToModule }) {
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(open);
    const [name, setName] = useState(text);
    const availableLan = useGetAvailableLanguages();
    const [isHovering, setIsHovering] = useState(false);

    React.useEffect(() => {
        setName(text);
    }, [text]);

    const [{ isDragging }, drag] = useDrag({
        type: "Question",
        item: { index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const [, drop] = useDrop({
        accept: "Question",
        hover: (item, monitor) => {
            if (!monitor.canDrop()) return;
            if (!isHovering) setIsHovering(true);
            const dragIndex = item.index;
            const hoverIndex = index;

            if (isOpen)  return; 
            onMove?.(dragIndex, hoverIndex);
            item.index = hoverIndex;
        },
        drop: (item, monitor) => {
            setIsHovering(false);
            onDrop?.(item); 
        },
        collect: monitor => {
            if (!monitor.isOver()) {
                setIsHovering(false); 
            }
            return {}; 
        }
    });

    const handleToModule = () => {
            onAddToModule?.(id);
    }

    const handleUpdate = (newName) => {
        if(newName.text) setName(newName.text);
        setIsOpen(false);
    }

    const opacity = isDragging ? 1 : 1;
    const dragRef = isOpen ? undefined : drag;

    const dropzoneStyle = {
        opacity: isHovering ? 0 : 1, 
    };

    return (
        <div ref={drop} style={dropzoneStyle} >
            <div ref={dragRef} style={{ opacity }}>
                <div className="questionWrap">
                    {!isOpen ? (
                        <>
                            {isSortable && (<span className="move"></span>)}
                            <input id={id} type="checkbox" checked={isSortable} onChange={(e, i) => handleToModule()} title="" />
                            <label htmlFor={id} title=""></label>
                            <div className="questionWrapDiv" onClick={(e, i) =>  setIsOpen(!isOpen)}>

                                {availableLan.map((lng, key) => {
                                    return (
                                        <span key={lng}>
                                            <strong>{lng}: </strong>
                                            {name && name.hasOwnProperty(lng) ? (
                                                <>
                                                    {name[lng]}
                                                    {!name[lng] && <span className="noTranslation" />}
                                                </>
                                            ) : (
                                                <span className="noTranslation" />
                                            )}
                                        </span>
                                    );
                                })}

                                <button type="button" className="btn btn-default btn-edit btn-editInput">{t("admin.common.edit")}</button>
                            </div>
                        </>
                    ) : (
                    <GroupQuestionsEditForm id={id} type={type} moduleId={moduleId} onClose={() => setIsOpen(false)} onConfirm={(e) => { handleUpdate(e) }} onAdd={() => handleToModule()} checked={isSortable} />)}
                </div>
            </div>
        </div>
    );
}

export default GroupQuestionsListItem;
